(ns ui.view.card.counterparty-diligence-progress.model)

(def change-status-confirmation-modal-open-path
  [:change-status-confirmation-modal-open?])

(defn change-status-confirmation-modal-open-full-path
  [card-state-path]
  (into card-state-path change-status-confirmation-modal-open-path))

(def change-to-status-path [:change-to-status])

(defn change-to-status-full-path
  [card-state-path]
  (into card-state-path change-to-status-path))

(def submitting-status-change-path [:submitting-status-change?])

(defn submitting-status-change-full-path
  [card-state-path]
  (into card-state-path submitting-status-change-path))

(def change-status-error-modal-open-path [:change-status-error-modal-open?])

(defn change-status-error-modal-open-full-path
  [card-state-path]
  (into card-state-path change-status-error-modal-open-path))

(def change-status-error-kw-path [:change-status-error-kw])

(defn change-status-error-kw-full-path
  [card-state-path]
  (into card-state-path change-status-error-kw-path))
